/* eslint-disable react-refresh/only-export-components --
 * The Provider and the consumer hook are co-located on purpose; they're
 * only used by OnboardingFlow + onboarding steps, so the Fast-Refresh
 * scope is already small and the file rarely changes. */
import { createContext, useContext, type ReactNode } from 'react';

interface OnboardingFooterContextValue {
  setFooter: (footer: ReactNode) => void;
}

const OnboardingFooterContext = createContext<OnboardingFooterContextValue>({
  setFooter: () => {},
});

export const OnboardingFooterProvider = OnboardingFooterContext.Provider;
export const useOnboardingFooter = () => useContext(OnboardingFooterContext);
